import {
  AnalysisItem,
  EchartDataType,
  LayerGroupType,
  LegendItem,
  LocationItem
} from "helpers/models";
import aggregationEchart from "report/common/aggregation-echart";
import filterLayerId from "report/common/filter-layer-id";
import groupByLayerIdValueLabel from "report/common/group-layer-value";
import transformRule from "report/common/rule";
import sortLayer from "report/common/sort-layer";
import sortLayerRule from "report/common/sort-layer-rule";
import sortLayerValue from "report/common/sort-layer-value";

const get = (
  locationItems: LocationItem[],
  analysisItems: AnalysisItem[],
  legendItems: LegendItem[],
  aggregationUnits: string[]
): EchartDataType => {
  if (!aggregationUnits) {
    return {};
  }

  const layerRuleOrder = sortLayerRule(legendItems);

  const groupData = groupByLayerIdValueLabel(analysisItems);
  const legend: LayerGroupType = transformRule(legendItems);

  const groupEchart = aggregationEchart(
    groupData,
    locationItems,
    legend,
    aggregationUnits
  );

  // const idArray = filterLayerId(groupEchart);

  // idArray.forEach((id) => {
  //   delete groupEchart[id];
  // });

  Object.keys(groupEchart).forEach((key) => {
    groupEchart[key] = sortLayer(groupEchart[key]);
  });

  sortLayerValue(groupEchart, layerRuleOrder);
  
  return groupEchart;
};

export default get;
